import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import VueAnalytics from 'vue-analytics'

Vue.use(Vuetify)
Vue.config.productionTip = false

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-144159165-10'
});

new Vue({
  vuetify : new Vuetify(),
  render: h => h(App),
}).$mount('#app')
